import classnames from "classnames";

import { ModalPortal } from "features/common/modals/components/ModalNodeContext";

import styles from "./ModalWrapper.module.scss";
import Overlay from "./Overlay";

type Props = {
  backLink?: string;
  onBackClick?: () => void;
  coverSiteHeader?: boolean;
  showOverlay?: boolean;
  renderTransitionWrapper: (arg0: { className: string }) => React.ReactNode;
  zIndex?: number;
};

export default function ModalWrapper({
  backLink,
  onBackClick,
  coverSiteHeader = true,
  showOverlay = true,
  renderTransitionWrapper,
  // TODO clean up z-index across app to prevent need for z-index prop
  zIndex = 10
}: Props) {
  return (
    <ModalPortal>
      <div
        className={classnames(styles.wrapper, {
          [styles.uncoveredHeaderWrapper]: !coverSiteHeader
        })}
        style={showOverlay ? { zIndex } : undefined}
      >
        {showOverlay && (
          <Overlay backLink={backLink} onBackClick={onBackClick} />
        )}
        {renderTransitionWrapper({
          className: styles.transitionWrapper
        })}
      </div>
    </ModalPortal>
  );
}
